module.exports = __webpack_public_path__ + "img/FullLogoWhite.2f0e3bc1.png";